import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { LanguageService } from '../../../core/services/language.service';

@Injectable({ providedIn: 'root' })
export class UnitService {
  private readonly baseUrl = environment.api.baseUrl;

  constructor(
    private http: HttpClient,
    private languageService: LanguageService,
  ) {}

  private get langHeaders() {
    const lang = this.languageService.getCurrentLanguage();
    return { 'Accept-Language': lang, 'Content-Language': lang, 'X-Language': lang };
  }

  getUnitById(id: string): Observable<unknown> {
    return this.http.get(`${this.baseUrl}/unit/${id}/rent`, { headers: this.langHeaders });
  }

  getUnitByIdForSale(id: string): Observable<unknown> {
    return this.http.get(`${this.baseUrl}/unit/${id}/sale`, { headers: this.langHeaders });
  }
}
